import React from 'react';
import { AiFillGithub } from "react-icons/ai";
import { BsTwitter } from "react-icons/bs";
import { IoMail } from "react-icons/io5";
import "./css/Contact.css"
import Footer from './Footer';
import Navbar from './Navbar';
import { DarkModeProvider } from './DarkModeContext';

function Contact (){

    

    return(
        <DarkModeProvider>
        <div>
        <Navbar />

        <div className="container" >
        <div class="container-item">
          <div class="title">Github</div>
          <div class="final">@Maximctrl</div>

            <h2>Github Projects</h2>

          <ul class="features">
            <li>NBA ML  <button> <a href='https://github.com/Maximctrl' target="_blank" rel="noopener noreferrer">View Project</a></button></li>
    
          </ul>
          
          <a href='https://github.com/WisAjayi/NBA-ML' target="_blank" rel="noopener noreferrer" style={{ cursor: 'pointer' }}>
          <AiFillGithub size={20} color={'black'} />
          </a>


        </div>


        <div class="container-item">
          <div class="title">Mail</div>
          <h3 >wisdomaajayi@gmail.com</h3>

          <a href='mailto:wisdomaajayi@gmail.com' target="_blank" rel="noopener noreferrer" style={{ cursor: 'pointer' }}>
          <IoMail size={20} color={'black'} />
          </a>
         
        </div>


        <div class="container-item">
          <div class="title">Projects</div>

          <ul class="features">
            <li>Daily Idiom <button> <a href='https://idiomaticexpressions.wisdomajayi.com/' target="_blank" rel="noopener noreferrer">View Project</a></button></li>
            <li>How Many Times <button> <a href='https://life.wisdomajayi.com/' target="_blank" rel="noopener noreferrer">View Project</a> </button></li>
            <li>NBA ML  <button> <a href='https://statsml.wisdomajayi.com/' target="_blank" rel="noopener noreferrer">View Project</a> </button></li>
            <li>Photography  <button> <a href='https://photography.wisdomajayi.com/' target="_blank" rel="noopener noreferrer">View Project</a> </button></li>

    
          </ul>


          <a href='https://twitter.com/' target="_blank" rel="noopener noreferrer" style={{ cursor: 'pointer' }}>
          <BsTwitter size={20} color={'black'} />
          </a>


        </div>

      </div>

      <Footer />
      </div>
    </DarkModeProvider>
    );
};

export default Contact;